import { render, staticRenderFns } from "./TableUserColumn.vue?vue&type=template&id=158f697d"
import script from "./TableUserColumn.vue?vue&type=script&lang=js"
export * from "./TableUserColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports